import Component from '@glimmer/component';
import { action } from '@ember/object';

export default class TimingPointSelectorComponent extends Component
{
	@action
	selectTimingPoint(event)
	{
		if(event.target.value == '-')
		{
			this.args.timingPointSelectionAction(null);
		}
		else
		{
			this.args.timingPointSelectionAction(event.target.value);
		}
	}
}
